<template>
  <div id="form-dados-pessoais" class="row mt-4">
    <div class="col-12">
      <form class="panel__content needs-validation" novalidate data-vv-validate-on="blur">
        <header class="panel__header mt-2">
          <h2 class="panel__title">
            {{ $t('SEU CPF') }}:
          </h2>
        </header>

        <div class="row">
          <p class="col-12 col-sm-6">
            <masked-input
              id="mask_cpf"
              v-validate="'required|cpf'"
              type="text"
              name="cpf"
              class="form-control"
              v-model="user.cpf"
              :class="{ 'is-invalid': errors.has('cpf') }"
              :mask="[/\d/,/\d/,/\d/,'.',/\d/,/\d/,/\d/,'.',/\d/,/\d/,/\d/,'-',/\d/,/\d/]"
              :guide="false"
              v-on:keydown.delete="onDeleteMask"
              @change="($event) => searchUserWithKey($event.target.value, '#modelIsCadSocio')"
              :placeholder="$t('000.000.000-00')"
            >
            </masked-input>

            <span class="invalid-feedback"> {{ errors.first("cpf") }} </span>
          </p>
          <p class="col-12 col-sm-6">
            {{ $t('Através da validação do seu CPF, identificaremos se você já tem registros em nosso Programa. Desta forma, daremos prosseguimento ao seu cadastro.') }}
          </p>
        </div>

        <header class="panel__header mt-2">
          <h2 class="panel__title">{{ $t('SEUS DADOS PESSOAIS') }}:</h2>
        </header>

        <div class="row">
          <p class="col-12 col-sm-6">
            <input
              :class="{ input: true, 'is-invalid': errors.has('nome') }"
              name="nome"
              v-validate="'required|alpha_spaces'"
              type="text"
              class="form-control"
              v-model="user.nome"
              id="nome"
              :placeholder="$t('Nome: João Paulo')"
              value=""
            />
            <span class="invalid-feedback"> {{ errors.first("nome") }} </span>
          </p>
          <p class="col-12 col-sm-6">
            <input
              :class="{ input: true, 'is-invalid': errors.has('sobrenome') }"
              name="sobrenome"
              v-validate="'required|alpha_spaces'"
              type="text"
              class="form-control"
              v-model="user.sobrenome"
              id="sobrenome"
              :placeholder="$t('Sobrenome: da Silva')"
              value=""
            />
            <span class="invalid-feedback">
              {{ errors.first("sobrenome") }}
            </span>
          </p>
        </div>

        <div class="row">
          <p class="col-12 col-sm-6">
            <input
              :class="{ input: true, 'is-invalid': errors.has('email') }"
              name="email"
              class="form-control"
              v-validate="'required|email'"
              v-model="user.email"
              id="email"
              placeholder="E-mail: "
              @change="($event) => searchUserWithKey($event.target.value, '#modelIsCadSocioEmail')"
              value=""
            />
            <span class="invalid-feedback"> {{ errors.first("email") }} </span>
          </p>
          <p class="col-12 col-sm-6">
            <masked-input
              v-on:keyup="ageVerify(user.datanascimento)"
              v-validate="{ required: true, datanasc: true, idadecompat:age_error }"
              type="text"
              name="datanascimento"
              class="form-control"
              :class="{ 'is-invalid': age_error + errors.has('datanascimento') }"
              v-model="user.datanascimento"
              :mask="[/\d/, /\d/, '/', /\d/, /\d/, '/', /\d/, /\d/, /\d/, /\d/]"
              v-on:keydown.delete="onDeleteMask"
              :guide="false"
              :placeholder="$t('Data de Nascimento: DD/MM/AAAA')"
            >
            </masked-input>

            <span class="invalid-feedback" v-if="errors.first('datanascimento')">
              {{ errors.first("datanascimento") }}
            </span>
          </p>
        </div>

        <div class="row">
          <p class="col-12 col-sm-6">
            <masked-input
              v-if="clube.id !== 2036"
              v-validate="'required|min:16'"
              type="text"
              name="celular"
              class="form-control"
              :class="{ 'is-invalid': errors.has('celular') }"
              v-model="user.celular"
              :mask="['(',/\d/,/\d/,')',' ',/\d/,'.',/\d/,/\d/,/\d/,/\d/,'-',/\d/,/\d/,/\d/,/\d/]"
              v-on:keydown.delete="onDeleteMask"
              :guide="false"
              :placeholder="$t('Celular') + ':'"
            >
            </masked-input>
            <vue-tel-input
              v-else
              v-validate="'required'"
              v-model="user.celular"
              default-country="BR"
              :input-options="{
                name: 'celular',
                placeholder: 'Celular: ',
                type: 'tel',
                styleClasses: errors.has('celular') ? 'form-control is-invalid' : 'form-control',
                required: true,
              }"
              :preferred-countries="['BR']"
              @input="onPhoneInput"
            ></vue-tel-input>

            <span class="invalid-feedback" :class="{ 'd-block': errors.has('celular') }">
              {{ errors.first("celular") }}
            </span>
          </p>
          <p class="col-12 col-sm-6">
            <select
              class="form-select"
              v-validate="'required'"
              v-model="user.sexo"
              :class="{ 'is-invalid': errors.has('sexo') }"
              name="sexo"
            >
              <option value="" selected disabled>{{ $t('Sexo') }}:</option>
              <option v-if="plano['somente_feminino'] == 'N'" value="M">{{ $t('Masculino') }}</option>
              <option value="F">{{ $t('Feminino') }}</option>
            </select>

            <span class="invalid-feedback"> {{ errors.first("sexo") }} </span>
          </p>
        </div>

        <div class="row">
          <div class="col-12 col-sm-6">
            <div class="password-wrapper">
              <input
                data-vv-as="senha"
                v-model="user.password"
                :class="{ 'is-invalid': errors.has('password') }"
                v-validate="'required|min:6|confirmed:password_confirm'"
                name="password"
                ref="password"
                :type="showPassword ? 'text' : 'password'"
                class="form-control"
                :placeholder="$t('Cria sua senha') + ':'"
              />
              
              <i
                class="fa password-icon"
                :class="showPassword ? 'fa-eye-slash' : 'fa-eye'"
                aria-hidden="true"
                @click="showPassword = !showPassword"
              ></i>
            </div>

            <span class="invalid-feedback d-block">
              {{ errors.first("password") }}
            </span>
          </div>
          <div class="col-12 col-sm-6">
            <div class="password-wrapper">
              <input
                data-vv-as="confirme sua senha"
                v-model="user.password_confirm"
                :class="{ 'is-invalid': errors.has('password_confirm') || errors.has('password') }"
                v-validate="'required'"
                name="password_confirm"
                ref="password_confirm"
                :type="showPassword ? 'text' : 'password'"
                class="form-control"
                :placeholder="$t('Confirme sua senha') + ':'"
              />

              <i
                class="fa password-icon"
                :class="showPassword ? 'fa-eye-slash' : 'fa-eye'"
                aria-hidden="true"
                @click="showPassword = !showPassword"
              ></i>
            </div>

            <span class="invalid-feedback d-block">
              {{ errors.first("password_confirm") }}
            </span>
          </div>
        </div>

        <div class="row">
          <div class="col-12 pt-5">
            <p>
              <input
                data-vv-as="termos de contrato"
                v-model="user.termoscontrato"
                :class="{ 'is-invalid': errors.has('termoscontrato') }"
                v-validate="'required'"
                name="termoscontrato"
                type="checkbox"
                class="form-check-input"
              />
              {{ $t('Li e aceito os') }}
              <a
                href="#"
                data-bs-toggle="modal"
                style="color: blue"
                data-bs-target="#termosdecontratoModal"
                >{{ $t('termos de contrato') }}</a
              >
              {{ $t('do programa') }}.
              <span class="invalid-feedback">
                {{ errors.first("termoscontrato") }}
              </span>
            </p>
            <p>
              <input
                v-model="user.receberinfo"
                name="receberinfo"
                type="checkbox"
                class="form-check-input"
                checked="checked"
              />
              {{ $t('Aceito receber informativos do programa via e-mail e Whatsapp') }}.
            </p>
          </div>
        </div>

        <div class="row">
          <div class="col-12">
            <b-alert
              variant="danger"
              dismissible
              :show="error.show"
              v-model="error.show"
            >
              <div>{{ error.text }}</div>
            </b-alert>
          </div>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import Vue from 'vue'
import { VueTelInput } from 'vue-tel-input';
import recaptcha from '../../plugins/recaptcha';

export default Vue.extend({
  components: {
    VueTelInput,
  },
  data() {
    return {
      fields: [
        'nome',
        'twitter',
        'instagram',
        'sobrenome',
        'email',
        'cpf',
        'datanascimento',
        'celular',
        'sexo',
        'password',
        'password_confirm',
        'termoscontrato',
      ],
      error: {
        show: false,
        text: '',
      },
      idade_inicial: '{{{ $plano["idade_inicial"] }}',
      idade_final: '{{ $plano["idade_final"] }}',
      age_error: false,
      showPassword: false,
      phoneValid: false,
      phoneE164: null
    }
  },
  props: {
    user: {
      required: true,
      type: Object
    },
    config: {
      required: true,
      type: Object
    },
    plano: {
      required: true,
      type: Object
    },
    clube: {
      required: true,
      type: Object
    },
  },
  methods: {
    async submit() {
      try {
        // This validation is necessary because this tenant uses a custom i18n phone input that
        // doesn't support the same validation rules.
        if (this.clube.id === 2036 && !this.phoneValid) {
          this.$validator.errors.add({
            field: 'celular',
            msg: this.$t('Número de celular inválido.')
          })

          throw new Error('Número de celular inválido.')
        }

        if (await this.$validator.validateAll()) {
          return await this.storeUser()
        } else {
          throw new Error('Preencha os campos corretamente')
        }
      } catch (error) {
        $("html, body").animate({scrollTop:$("#cadastroSocio").offset().top - 10}, 500, 'swing');
        return false
      }
    },
    onPhoneInput(_value, phoneObject) {
      this.phoneValid = phoneObject.valid === true
      this.phoneE164 = this.phoneValid ? phoneObject.number : null

      if (this.phoneValid) {
        this.$validator.errors.remove('celular')
      }
    },
    async searchUserWithKey(key, modalToOpen = '#modelIsCadSocio') {
      const response = await axios.get('/api/is_cad_socio/' + key)
      
      if(response.data > 0){
        $(modalToOpen).modal({
          backdrop: 'static',
          keyboard: false
        }).modal('show');
      }
    },
    async storeUser() {
      try {
        const token = await recaptcha()

        const celular = this.clube.id === 2036 && this.phoneE164 ? this.phoneE164 : this.user.celular

        const response = await axios.post('/cadastro/dados-pessoais', {
          ...this.user,
          celular,
          token,
          plano: this.plano
        })

        if(response.data.error && !response.data.usuario) {
          this.error.show = true
          this.error.text = response.data.message
          return false
        } else {
          this.user.id = response.data.data.id
          return true
        }
      } catch (error) {
        this.error.show = true

        const errors = error.response?.data?.errors

        if (errors?.cpf?.[0]) {
          this.error.text = this.$t("CPF já consta na base de dados.")
        } else if (errors?.email?.[0]) {
          this.error.text = this.$t("E-mail já consta na base de dados.")
        } else if (errors?.celular?.[0]) {
          this.error.text = errors.celular[0]
        } else {
          this.error.text = this.$t("Erro interno, tente novamente mais tarde.")
        }
        
        return false
      }
    },
    ageVerify(value) {
      let dateOfBirth = value;
      let currentYear = new Date().getFullYear();
      let currentDate = new Date();
      let dayOfBirth = dateOfBirth.split('/')[0];
      let monthOfBirth = dateOfBirth.split('/')[1];
      let yearOfBirth = dateOfBirth.split('/')[2]; 
      let age = currentYear - yearOfBirth;
      let currentMonth = currentDate.getMonth() + 1;
      
      if(currentMonth < monthOfBirth){
        age--; 
      } else {
          if(currentMonth == monthOfBirth){ 
              if(new Date().getDate() <  dayOfBirth){ 
                age--;
              }
          }
      } 

      if(age < this.plano.idade_inicial || age > this.plano.idade_final) {
          this.age_error = true;
      } else {
        this.age_error = false;
      }
    },

    // Não faço a menor ideia do que isso faz, originalmente foi escrito pelo David Petter.
    onDeleteMask(event) {
      let value = event.target.value; 
      let char = value[value.length-1];
      if (isNaN(parseInt(char)) || char == ' ') { event.target.value = value.substring(0, value.length-1); }
    }
  }
})
</script>

<style>
.password-wrapper {
  position: relative;
}

.password-wrapper input {
  padding-right: 45px;
}

.password-icon {
  position: absolute;
  right: 16px;
  top: 50%;
  transform: translateY(-50%);
  cursor: pointer;
  color: #6c757d;
  z-index: 10;
}
</style>
